import { useEffect } from 'react';
import { identifyUser, setUserCompany } from '../lib/posthog';
import { useUser } from './useUser';

/**
 * A hook that identifies the current user in PostHog
 * using their email as the identifier.
 * 
 * Also sets up company group tracking if the user has a company.
 */
export const usePostHogUser = (companyId?: number | null, companyName?: string) => {
  const { user } = useUser();

  useEffect(() => {
    // Skip if no user is logged in or has no email
    if (!user || !user.email) return;

    // Identify user with their email as ID
    identifyUser({
      id: user.id,
      email: user.email,
      user_metadata: user.user_metadata as Record<string, unknown>
    });

    // Set up company group if company info is provided
    if (companyId) {
      setUserCompany(companyId, companyName || '');
    }
  }, [user, companyId, companyName]);

  return null; // This hook doesn't return anything useful
}; 